import { ConfigElement } from '../components-fabric';
import { publicAreaScreens } from './public/screens';
import { managementAreaSection } from './management/screens';
import { lecturersAreaScreens } from './lecturers/screens';
import { studentsAreaScreens } from './students/screens';
import { buildingConfigurationsScreens } from './building-configurations/screens';
import { componentsDbScreens } from './components-db/screens';
import { assignmentsSection } from './assignments/screens';
import { courseScreens } from './courses/courses.screens';

/**
 * Configuration Array: webSiteScreens
 * 
 * This array contains the configuration for all website screens. 
 * It includes public area screens, management area sections, assignments sections, 
 * lecturers area screens, students area screens, course screens, building configuration screens,
 * components database screens, and test screens.
 * 
 * @property {Array} webSiteScreens - An array of configuration elements for the website.
 */
export const webSiteScreens: ConfigElement[] = [
  ...publicAreaScreens,
  managementAreaSection,
  assignmentsSection,
  lecturersAreaScreens,
  studentsAreaScreens,
  courseScreens,
  buildingConfigurationsScreens,
  ...componentsDbScreens,
];
